import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  styled,
} from '@mui/material';

export const BackSoonIcon = styled(Box)(
  () => `
  margin-right:12.9375rem;
  padding-top: 10px;
`,
);

export const CustomStyledAlert = styled(Alert)(
  ({ theme }) => `
  margin-top:1rem;
  margin-bottom:1rem;
  background-color:${theme.palette.brand.whitesmoke};
  color: ${theme.palette.brand.charcoal};
  text-align: center;
  `,
);

export const BackSoonAccordion = styled(Accordion)`
  margin: 0.9375rem 0 0;
  padding: 0.9375rem 0;

  &.Mui-expanded {
    margin: 0.9375rem 0 0;
  }
`;

export const BackSoonAccordionDetails = styled(AccordionDetails)`
  padding: 0;
`;

export const BackSoonAccordionSummary = styled(AccordionSummary)(
  ({ theme }) => `
      padding: 0;
      border-bottom: 1px solid ${theme.palette.common.black};

    & .MuiAccordionSummary-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  `,
);

export const BackSoonAccordionSummaryContent = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
